export default __webpack_public_path__ + "static/media/Blade of the Void.e3c50fbf.jpg";